import React, { useEffect, useMemo, useState } from 'react'
import BasicCard from '../../../components/card/basiccard/BasicCard'
import Icons from '../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import TextInput from '../../../components/input/textinput/TextInput'
import { RECORDS_TO_SHOW_PER_PAGE } from './Constants'
import Pagination from '../../../components/richgrid/Pagination'
import styles from "./SelectOptionModal.style"
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants'

const SelectOptionModal = ({ options, selectedOption, isSearchable = true, onSelectCb }) => {

    const [searchTerm, setSearchTerm] = useState("")
    const [paginationState, setPaginationState] = useState({
        currentPage: 1,
        pageSize: RECORDS_TO_SHOW_PER_PAGE,
        skip: 0,
    });
    const [displayOptions, setDisplayOptions] = useState([])

    const filteredRecords = useMemo(() => {
        setPaginationState({ ...paginationState, currentPage: 1 });
        if (isSearchable) {
            return options.filter((opt) => {
                if (opt.label.toLowerCase().includes(searchTerm.toLowerCase())) {
                    return opt;
                }
            });
        } else {
            return options
        }
    }, [searchTerm, options]);

    useEffect(() => {
        const startIndex = (paginationState.currentPage - 1) * paginationState.pageSize;
        let paginatedRecords = filteredRecords.slice(startIndex, startIndex + paginationState.pageSize);

        if (selectedOption.value) {
            const filterRecords = paginatedRecords.filter((record) => record?.value !== selectedOption.value)
            paginatedRecords = [selectedOption, ...filterRecords]
        }

        setDisplayOptions(paginatedRecords)
    }, [paginationState.currentPage, paginationState.pageSize, filteredRecords, selectedOption.value]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    }

    return (
        <div style={styles.selectOptionsWrapper}>
            <div style={styles.searchContainer}>
                <TextInput
                    type="text"
                    value={searchTerm}
                    placeHolder={`Search by Name...`}
                    onChangeCb={handleSearchChange}
                    suffixProps={{ icon: VEC_ICON_NAME.SEARCH_ICON }}
                />
            </div>
            <div style={styles.cardsContainer}>
                {displayOptions?.length > 0 ? displayOptions?.map((option, index) => {
                    return <BasicCard key={'display-option-' + index} customStyles={styles.cardBody} isHighlighted={selectedOption.value === option.value}>
                        <div onClick={() => onSelectCb(option)} style={styles.singleOptionContainer}>
                            <Icons familyName="vec" iconName={VEC_ICON_NAME.PAYER_TYPE_BUSINESS_SMALL} />
                            <div style={styles.labelContainer}>
                                <span style={styles.optionLabel}>{option.label}</span>
                            </div>
                        </div>
                    </BasicCard>

                    }) : <div syyle={styles.noRecordsDiv}>No records found</div>
                }
            </div>

            <div style={styles.footerSyles}>
                <Pagination
                    skip={paginationState.skip}
                    take={paginationState.pageSize}
                    total={options.length}
                    takeOptions={ROW_SELECTION_OPTIONS}
                    onChange={(take, t) => {
                        setPaginationState({ ...paginationState, skip: t, currentPage: Math.ceil((take + t) / take) })
                    }}
                    onChangeTakeCb={(newTake) => {
                        setPaginationState({ ...paginationState, pageSize: newTake, currentPage: 1, skip: 0 })
                    }}
                />
            </div>
        </div>
    )
}

export default SelectOptionModal